import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import moment from 'moment';
import { useContext } from 'react';
import { useSearchInput } from 'hooks/useSearchInput';
import { AppContext } from 'shared/AppContext';

const CommonEventFieldsFragment = gql`
  fragment trackEventFields on Event {
    id
    name
    fullDate
    start_date
    end_date
    off_sale_time
    admin_website_url
    image
    logo
    status
    isMultiDay
    listDates
    day
    date
    month
    year
    sale_start
    registration_sale_start
    track {
      id
      name
    }
  }
`;

export const GET_TRACK_EVENTS = gql`
  query GetTrackEvents($input: GetAccountEventsInput!) {
    getEventsByAccount(input: $input) {
      count
      results {
        ...trackEventFields
        nextGateTime
        tickets {
          name
          price
          date
        }
        other_tickets {
          name
          price
        }
      }
    }
  }
  ${CommonEventFieldsFragment}
`;

export function useGetTrackEvents(appliedStartDate = '', appliedEndDate = '') {
  const { input: search } = useSearchInput();
  const {
    state: { accountId },
  } = useContext(AppContext);

  // Only include queryString from search params for GraphQL
  const queryString = search.queryString || '';

  // Get page number from URL (as string for this API)
  const page = search.page ? String(search.page) : '1';

  // Build input with optional date filters
  const input = {
    queryString,
    account_id: accountId,
    page,
  };

  // Add date filters if provided - convert from YYYY-MM-DD (DateTimePicker) to MM-DD-YYYY (GraphQL)
  if (appliedStartDate) {
    input.start_date = moment(appliedStartDate, 'YYYY-MM-DD').format(
      'MM-DD-YYYY'
    );
  }
  if (appliedEndDate) {
    input.end_date = moment(appliedEndDate, 'YYYY-MM-DD').format('MM-DD-YYYY');
  }

  // If no date filters, default to current year for backwards compatibility
  if (!appliedStartDate && !appliedEndDate) {
    const thisYear = Number(moment().format('YYYY'));
    input.year = thisYear;
  }

  const result = useQuery(GET_TRACK_EVENTS, {
    variables: {
      input,
    },
    fetchPolicy: 'cache-and-network',
  });

  return result;
}
